"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

var _iconPhone = _interopRequireDefault(require("../../../shared/icons/icon-phone.svg"));

var _iconEnvelope = _interopRequireDefault(require("../../../shared/icons/icon-envelope.svg"));

var _iconChat = _interopRequireDefault(require("../../../shared/icons/icon-chat.svg"));

var _iconLink = _interopRequireDefault(require("../../../shared/icons/icon-link.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var iconMap = {
  Phone: _iconPhone["default"],
  Email: _iconEnvelope["default"],
  Chat: _iconChat["default"],
  Link: _iconLink["default"]
};
var defaultLabelMap = {
  Email: 'Email',
  Phone: 'Call',
  Chat: '',
  Link: ''
};

var ContactPoint = function ContactPointComponent(_ref) {
  var type = _ref.type,
      labelOverride = _ref.labelOverride,
      contactPointContent = _ref.contactPointContent;
  var Icon = iconMap[type];
  var label = labelOverride || defaultLabelMap[type];
  var contactPoint;

  switch (type) {
    case 'Email':
      contactPoint = /*#__PURE__*/_react["default"].createElement("a", {
        className: "content-page__contact-link",
        href: "mailto:".concat(contactPointContent[0].text)
      }, contactPointContent[0].text);
      break;

    case 'Phone':
      contactPoint = /*#__PURE__*/_react["default"].createElement("a", {
        className: "content-page__contact-link",
        href: "tel:".concat(contactPointContent[0].text)
      }, contactPointContent[0].text);
      break;

    default:
      contactPoint = /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
        baseClass: "content-page__contact-point",
        content: contactPointContent,
        options: {
          hyperlink: 'WithExternalLinkIcon'
        }
      });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__contact-point",
    role: "heading",
    "aria-level": 4
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "content-page__contact-icon",
    role: "none"
  }), label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "content-page__contact-label"
  }, label), contactPoint);
};

ContactPoint.propTypes = {
  type: _propTypes["default"].oneOf(['Phone', 'Email', 'Chat', 'Link']).isRequired,
  labelOverride: _propTypes["default"].string,
  contactPointContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
ContactPoint.defaultProps = {
  labelOverride: null
};
var _default = ContactPoint;
exports["default"] = _default;